// ABOUTME: The grid tab of the "nooit verkochte producten" report — a ShDataGrid3 of the relation's never-sold
// ABOUTME: products, filtered by the shared date range + the active card tile (staleDays / withStock).
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ShDataGrid3 from "../../../../../components/theme/datagrid3/ShDataGrid3";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../../components/theme/text/Text";
import { formatPrice, formatNumber } from "../../../../../utils/helpers";
import { useGetNeverSoldListQuery } from "../../../../../newapi/reports/relation/reportRelationNeverSoldSlice";

const NeverSold = (props) => {
    const { t, i18n } = useTranslation();
    const { dates, filter } = props;

    // The grid query body = date range + whichever card tile is active.
    const gridConfig = {
        startDate: dates.startDate,
        endDate: dates.endDate,
        ...(filter?.staleDays ? { staleDays: filter.staleDays } : {}),
        ...(filter?.withStock ? { withStock: true } : {}),
    };

    const columns = [
        {
            field: "sku",
            headerName: t("sku"),
            flex: 1,
            renderCell: (p) => (p.row.skeleton ? <ShTextSkeleton /> : <Text>{p.row.sku}</Text>),
        },
        {
            field: "description",
            headerName: t("product"),
            flex: 2,
            renderCell: (p) => (p.row.skeleton ? <ShTextSkeleton /> : <Text>{p.row.description}</Text>),
        },
        {
            field: "voorraad",
            headerName: t("voorraad"),
            flex: 1,
            renderCell: (p) => (p.row.skeleton ? <ShTextSkeleton /> : formatNumber(i18n, p.row.voorraad)),
        },
        {
            field: "laatstVerkocht",
            headerName: t("laatst_verkocht"),
            flex: 1,
            renderCell: (p) => {
                if (p.row.skeleton) return <ShTextSkeleton />;
                return p.row.last_sold ? new Date(p.row.last_sold).toLocaleDateString(i18n.language) : t("nooit");
            },
        },
        {
            field: "voorraadwaarde",
            headerName: t("voorraadwaarde"),
            flex: 1,
            renderCell: (p) => (p.row.skeleton ? <ShTextSkeleton /> : formatPrice(i18n, p.row.voorraadwaarde)),
        },
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            <ShDataGrid3
                gridKey="relation_neversold"
                content={useGetNeverSoldListQuery}
                config={gridConfig}
                columns={columns}
                gridOptions={{ export: true }}
                title={t("never_sold_products")}
                sortModel={{ field: "voorraad", type: "DESC" }}
                sort={{ field: "voorraad", type: "DESC" }}
            />
        </Box>
    );
};

export default NeverSold;
